import { render, staticRenderFns } from "./real-authentication.vue?vue&type=template&id=96b7aaaa&scoped=true&"
import script from "./real-authentication.vue?vue&type=script&lang=ts&"
export * from "./real-authentication.vue?vue&type=script&lang=ts&"
import style0 from "./real-authentication.vue?vue&type=style&index=0&id=96b7aaaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b7aaaa",
  null
  
)

export default component.exports